import { readCookie, writeCookieWithOptions } from '@/helpers/helpers';
import { ATTRIBUTION_KEYS } from '@/helpers/Tracker';

// First-touch campaign context (PAE-2465, data-model.md). Captured from the effective page URL —
// the WordPress parent's URL when framed — and attached to the registration event and signup request.
export const COOKIE_NAME = 'tb_attr';
export const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
export const ATTRIBUTION_PARAMS = ATTRIBUTION_KEYS;

export const cookieDomain = (hostname) => {
  if(typeof hostname === 'string' && (hostname === 'tinybeans.com' || hostname.endsWith('.tinybeans.com'))) {
    return '.tinybeans.com';
  }
  return undefined;
};

const parseQuery = (url) => {
  const found = {};
  if(typeof url !== 'string') {
    return found;
  }
  const queryStart = url.indexOf('?');
  if(queryStart < 0) {
    return found;
  }
  const query = url.slice(queryStart + 1).split('#')[0];
  query.split('&').forEach((pair) => {
    if(!pair) {
      return;
    }
    const eq = pair.indexOf('=');
    const key = decodeURIComponent(eq >= 0 ? pair.slice(0, eq) : pair);
    const value = eq >= 0 ? decodeURIComponent(pair.slice(eq + 1).replace(/\+/g, ' ')) : '';
    if(ATTRIBUTION_PARAMS.indexOf(key) >= 0 && value !== '') {
      found[key] = value;
    }
  });
  return found;
};

export const read = () => {
  const raw = readCookie(COOKIE_NAME);
  if(!raw) {
    return {};
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch(e) {
    return {};
  }
};

// First touch: an existing unexpired cookie is never overwritten; a visit with no attribution
// parameters writes nothing, so an organic visit never blocks a later paid one.
export const capture = (url) => {
  const found = parseQuery(url);
  if(Object.keys(found).length === 0) {
    return read();
  }
  const existing = read();
  if(Object.keys(existing).length > 0) {
    return existing;
  }
  const value = { ...found, ts: Date.now() };
  writeCookieWithOptions(COOKIE_NAME, JSON.stringify(value), {
    domain: cookieDomain(window.location.hostname),
    maxAgeSeconds: MAX_AGE_SECONDS,
    sameSite: 'Lax'
  });
  return value;
};
